var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "signUpForm" }, [
    _c("div", { staticClass: "center" }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("resetPasswordSubmitPage.title")))]),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(_vm.$t("resetPasswordSubmitPage.description")),
        },
      }),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("resetPasswordSubmitPage.userLabel")) +
                ": " +
                _vm._s(_vm.username)
            ),
          ]),
          _c(
            "div",
            [
              _c("text-field", {
                attrs: {
                  label: _vm.$t("resetPasswordSubmitPage.confirmCodeLabel"),
                  maxlength: 6,
                },
                model: {
                  value: _vm.code,
                  callback: function ($$v) {
                    _vm.code = $$v
                  },
                  expression: "code",
                },
              }),
              _c("text-field", {
                attrs: {
                  label: _vm.$t("resetPasswordSubmitPage.newPasswordLabel"),
                  type: "password",
                },
                model: {
                  value: _vm.newPassword,
                  callback: function ($$v) {
                    _vm.newPassword = $$v
                  },
                  expression: "newPassword",
                },
              }),
              _c("div", { staticClass: "attention" }, [
                _vm._v(
                  _vm._s(_vm.$t("resetPasswordSubmitPage.passwordRequirement"))
                ),
              ]),
              _c("button-default", [
                _vm._v(_vm._s(_vm.$t("resetPasswordSubmitPage.submitButton"))),
              ]),
            ],
            1
          ),
          _vm.message ? _c("div", [_vm._v(_vm._s(_vm.message))]) : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }